// extracted by mini-css-extract-plugin
export default {"date":"DateRange_date__r74nC"};